import { render, staticRenderFns } from "./FieldsConfig.vue?vue&type=template&id=95ba8acc&scoped=true&lang=pug&"
import script from "./FieldsConfig.vue?vue&type=script&lang=js&"
export * from "./FieldsConfig.vue?vue&type=script&lang=js&"
import style0 from "./FieldsConfig.vue?vue&type=style&index=0&id=95ba8acc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ba8acc",
  null
  
)

export default component.exports